<template>
	<div class="wrapper">
		<div class="header">
			<div class="title">商家个人中心</div>
			<div class="head-img"><img :src="shopInfo.logo" alt="" /></div>
			<div class="user-name">{{ shopInfo.name }}</div>
		</div>

		<div class="content">
			<div class="price-box">
				<div class="price-item" @click="handleRefresh">
					<p class="price">{{ balance }}</p>
					<p>余额（元）</p>
				</div>
				<div class="price-item" @click="handleShowTx"><span>提现</span></div>
			</div>
			<div class="option" v-if="shopInfo.status === 3"><van-cell title="补签协议" icon="refund-o" is-link @click="handleGoContract" /></div>
			<div class="option" v-else-if="shopInfo.status === 4"><van-cell title="已签协议，请等待最终审核" icon="refund-o" /></div>
			<div class="option" v-else>
				<van-cell title="获取我的收款码" icon="refund-o" is-link @click="handleShowPayCode" />
				<van-cell title="获取我的兑换码" icon="qr" is-link @click="handleShowDHCode" />
				<van-cell title="视频广场视频上传" icon="live" is-link to="shopaddvideolive" />
				<van-cell title="数据统计" icon="orders-o" is-link to="shopStatistics" />
				<van-cell title="上传介绍" icon="balance-list-o" is-link @click="goH5Views('https://www.shoudaole.cn/h5/sc/')" />
				<van-cell title="视频上传" icon="todo-list-o" is-link to="shopaddvideo" />
				<van-cell title="我的商品" icon="qr" is-link to="myShopGoodsList" />
				<van-cell title="收款记录" icon="after-sale" is-link to="shopConsumeList" />
				<van-cell title="提现记录" icon="balance-list-o" is-link to="shopCashList" />
				<van-cell title="活动编辑" icon="cash-on-deliver" is-link to="shopactivity" />
				<van-cell title="锁客提成列表" icon="todo-list-o" is-link to="shopLockGuestTCList"  />
				<van-cell title="修改提现密码" icon="closed-eye" is-link @click="handleGoRetrievePayPass" />
				<van-cell title="退出登录" icon="exchange" @click="getOut" is-link />
			</div>
		</div>
		<!-- <div id="bdtts_div_id" style="display: none;">
			<audio id="tts_autio_id" autoplay="autoplay">
				<source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=9&text=播报内容" type="audio/mpeg" />
				<embed id="tts_embed_id" height="0" width="0" src="" />
			</audio>
		</div> -->
		<!-- <button @click="baiduRadio()">测试</button> -->
		<van-overlay :show="showOverlay" @click="handleClear" />
		<div class="code" v-if="showCode">
			<p>{{ title }}</p>
			<div><img :src="codeUrl" alt="" /></div>
			<p>长按保存</p>
		</div>
	</div>
</template>

<script>
import { getShopInfoService } from '../service/shopService';
import { mapState } from 'vuex';
import { Dialog, Toast } from 'vant';
import { getOutService } from '../service/shopService';
import Cookies from 'js-cookie';
//import {wecharShare} from "../util/weChat.js";

export default {
	name: 'ShopInfo',
	data() {
		return {
			shopInfo: {},
			showTXBox: false,
			showOverlay: false,
			codeUrl: '', //二维码地址
			showCode: false,
			title: '我的收款码', //二维码标题
			balance: 0,
			websock: null, //建立的连接
			lockReconnect: false, //是否真正建立连接
			timeout: 28 * 1000, //30秒一次心跳
			timeoutObj: null, //心跳心跳倒计时
			serverTimeoutObj: null, //心跳倒计时
			timeoutnum: null, //断开 重连倒计时
			audio: new Audio()
		};
	},
	// created() {

	// },
	destroyed() {
		console.log('页面销毁');
		if (this.websock != null) {
			//页面销毁时关闭长连接
			this.websock.close();
		}
	},
	mounted() {
		if (this.shopId && this.shopId !== 'null') {
			this.getShopInfo();
		} else {
			Cookies.remove('o_tel');
			this.$router.push({
				name: 'shopLogin'
			});
		}
		//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
	},
	methods: {
		// 跳转H5页面
		goH5Views(url) {
			location.href = url + '?shopId=' + this.shopId;
		},
		initWebSocket() {
			//建立连接
			//初始化weosocket
			//const wsuri = "ws://sms.填写您的地址.com/websocket/" + this.charId; //ws地址
			// const wsuri = 'wss://47.110.149.93:9502';
			const wsuri = 'wss://82.157.47.113:9502';// wssocket链接，后端需要配置wss
			//建立连接
			this.websock = new WebSocket(wsuri);
			//连接成功
			this.websock.onopen = this.websocketonopen;
			//连接错误
			this.websock.onerror = this.websocketonerror;
			//接收信息
			this.websock.onmessage = this.websocketonmessage;
			//连接关闭
			this.websock.onclose = this.websocketclose;
		},
		reconnect() {
			//重新连接
			var that = this;
			if (that.lockReconnect) {
				return;
			}
			that.lockReconnect = true;
			//没连接上会一直重连，设置延迟避免请求过多
			that.timeoutnum && clearTimeout(that.timeoutnum);
			that.timeoutnum = setTimeout(function() {
				//新连接
				that.initWebSocket();
				that.lockReconnect = false;
			}, 5000);
		},
		reset() {
			//重置心跳
			var that = this;
			//清除时间
			clearTimeout(that.timeoutObj);
			clearTimeout(that.serverTimeoutObj);
			//重启心跳
			that.start();
		},
		start() {
			console.log('心跳');
			//开启心跳
			var self = this;
			self.timeoutObj && clearTimeout(self.timeoutObj);
			self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
			self.timeoutObj = setTimeout(function() {
				//这里发送一个心跳，后端收到后，返回一个心跳消息，
				if (self.websock.readyState == 1) {
					//如果连接正常
					// self.websock.send('{"shopId":' + self.shopId + '}');
					self.websocketsend();
				} else {
					//否则重连
					self.reconnect();
				}
				self.serverTimeoutObj = setTimeout(function() {
					//超时关闭
					self.websock.close();
				}, self.timeout);
			}, self.timeout);
		},

		websocketonopen() {
			//连接成功事件

			//提示成功
			console.log('连接成功');
			//开启心跳
			this.start();
			this.websocketsend(); // 发送第一条消息记录shopId
		},

		websocketonerror(e) {
			//连接失败事件
			//错误
			console.log('WebSocket连接发生错误', e);
			//错误提示
			//重连
			this.reconnect();
		},
		websocketclose(e) {
			//连接关闭事件
			//关闭
			console.log('connection closed', e);
			//提示关闭
			//重连
			this.reconnect();
		},
		websocketonmessage(event) {
			var data = JSON.parse(event.data);
			//接收服务器推送的信息
			//打印收到服务器的内容
			console.log('服务器消息:-----------', data);
			if (data.type == 'play') {
				this.playRadio(data.data);
				// this.baiduRadio(data.data);
			}
			//收到服务器信息，心跳重置
			this.reset();
		},
		websocketsend() {
			let msg = this.shopInfo.id;
			//向服务器发送信息
			//数据发送
			console.log('发送消息：', msg);
			this.websock.send(msg);
		},

		// 百度转换音频
		baiduRadio(text) {
			console.log(text);
			var ttsDiv = document.getElementById('bdtts_div_id');
			var ttsAudio = document.getElementById('tts_autio_id');
			var ttsText = encodeURI(text);
			ttsDiv.removeChild(ttsAudio);
			var au1 = '<audio id="tts_autio_id" autoplay="autoplay">';
			var sss = '<source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=Zh&ie=UTF-8&spd=4&text=' + ttsText + '" type="audio/mpeg">';
			var eee = '<embed id="tts_embed_id" height="0" width="0" src="">';
			var au2 = '</audio>';
			ttsDiv.innerHTML = au1 + sss + eee + au2;
			ttsAudio = document.getElementById('tts_autio_id');
			ttsAudio.play();
		},
		// 播放音频
		playRadio(src_server) {
			console.log('src_server', src_server);
			var that = this;
			var second = 10;
			this.audio.src = src_server;
			let playPromise;
			playPromise = this.audio.play();
			if (playPromise) {
				playPromise
					.then(() => {
						// 音频加载成功
						// 音频的播放需要耗时
						that.tiemr = setInterval(() => {
							second--;
							console.log('play' + second);
							if (second <= 0) {
								that.audio.pause();
								clearInterval(that.tiemr);
							}
						}, 1000);
					})
					.catch(e => {
						// 音频加载失败
						console.error(e);
					});
			}
		},
		// websocket--end

		//补签协议
		handleGoContract() {
			this.$router.push({
				name: 'shopContract',
				params: {
					shopId: this.shopInfo.id,
					contractImg: this.shopInfo.ht,
					contractRet: this.shopInfo.agreement_img,
					tel: this.shopInfo.tel
				}
			});
		},

		//提现
		handleShowTx() {
			const price = Math.floor(this.balance * 100) / 100;
			if (this.shopInfo.zf_status === 0) {
				Dialog.confirm({
					title: '提示',
					message: '您还未设置提现密码，前去设置'
				})
					.then(() => {
						this.$router.push({
							name: 'shopRetrievePayPass',
							params: {
								balance: this.balance
							}
						});
					})
					.catch(() => {});
			} else {
				this.$router.push({
					name: 'shopTX',
					params: {
						balance: this.balance
					}
				});
			}
		},

		handleClear() {
			this.showOverlay = false;
			this.showCode = false;
		},

		//获取商家个人信息
		getShopInfo() {
			const that = this;
			getShopInfoService(this.shopId)
				.then(res => {
					if (res.status === 1) {
						// 连接websocket
						that.initWebSocket();
						// if(res.datas.openid && res.datas.openid !== Cookies.get('o_id')){
						//     Dialog.alert({
						//         title:'提示',
						//         message:'您的账号在其他地方登录，请重新登录'
						//     }).then(() => {
						//         this.$router.push({
						//             name:'shopLogin'
						//         })
						//     })
						// }else if(res.datas.openid){
						//     this.shopInfo = res.datas;
						//     this.balance = this.shopInfo.balance;
						// }else{
						//     this.$router.push({
						//         name:'shopLogin'
						//     })
						// }
						if (res.datas.openid) {
							this.shopInfo = res.datas;
							this.balance = this.shopInfo.balance;
						} else {
							this.$router.push({
								name: 'shopLogin'
							});
						}
						// if(res.datas.openid){
						//     this.shopInfo = res.datas;
						//     this.balance = this.shopInfo.balance;
						// }else{
						//     this.$router.push({
						//         name:'shopLogin'
						//     })
						// }
					} else {
						alert(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},

		//获取我的收款码
		handleShowPayCode() {
			this.title = '我的收款码';
			this.handleShowCode(this.shopInfo.qrcode_pay);
		},

		//获取我的兑换码
		handleShowDHCode() {
			this.title = '我的兑换码';
			this.handleShowCode(this.shopInfo.qrcode_goods);
		},

		//显示二维码
		handleShowCode(url) {
			this.showOverlay = true;
			this.showCode = true;
			this.codeUrl = url;
		},

		//刷新
		handleRefresh() {
			this.$router.go(0);
		},

		//修改提现密码
		handleGoRetrievePayPass() {
			this.$router.push({
				name: 'shopRetrievePayPass',
				params: {
					balance: -1
				}
			});
		},

		//退出登录
		getOut() {
			Dialog.confirm({
				title: '提示',
				message: '确定退出吗'
			})
				.then(() => {
					getOutService(this.shopId).then(res => {
						Cookies.remove('o_tel');
						if (res.status === 1) {
							this.$router.push({
								name: 'home'
							});
						}
					});
				})
				.catch(() => {
					// on cancel
				});
		}
	},
	computed: {
		...mapState({
			shopId: state => state.userInfo.shopId
		})
	}
};
</script>

<style scoped lang="scss">
.wrapper {
	position: relative;
	.header {
		// background-image: url('../assets/img/icon/mybg.png');
		background-image: linear-gradient(to left, #00BFFF, #A9F0F8); /* 自右向左 */
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 30px 0;
		.title {
			color: #fff;
			font-size: 14px;
			font-weight: bold;
		}
		.head-img {
			width: 80px;
			height: 80px;
			margin: 10px 0;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
		.user-name {
			font-weight: bold;
			color: #fff;
		}
	}

	.content {
		background-color: #fdfbfb;
		position: relative;
		.price-box {
			position: absolute;
			z-index: 1;
			padding: 20px;
			width: 300px;
			box-sizing: border-box;
			right: 50%;
			margin-right: -160px;
			top: -20px;
			background: #ffffff;
			display: flex;
			box-shadow: 0px 3px 17px 1px rgba(203, 201, 197, 0.23);
			border-radius: 10px;
			.price-item {
				flex: 1;
				text-align: center;
				&:nth-child(1) {
					border-right: 1px solid #b9b9b9;
				}
				&:nth-child(2) {
					display: flex;
					align-items: center;
					justify-content: center;
					span {
						background: #ffb833;
						font-size: 16px;
						color: #ffffff;
						padding: 5px 10px;
						box-sizing: border-box;
						border-radius: 10px;
					}
				}
				p {
					color: #333333;
				}
				.price {
					font-size: 18px;
					color: #ffb833;
				}
			}
		}
		.option {
			padding-top: 70px;
		}
	}
	.tx {
		position: absolute;
		top: 20%;
		width: 100%;
		height: 100%;
		z-index: 999;
		.item {
			margin-bottom: 10px;
			padding: 10px;
			box-sizing: border-box;
		}
	}
	.code {
		position: absolute;
		top: 20%;
		width: 100%;
		/*height: 100%;*/
		z-index: 999;
		display: flex;
		align-items: center;
		/*justify-content: center;*/
		flex-direction: column;
		p {
			margin: 10px 0;
			font-size: 16px;
			color: #ffffff;
		}
	}
	.icon {
		width: 24px;
		height: 24px;
	}
}
</style>

<style scoped>
.van-cell {
	background-color: #fdfbfb;
	color: #444444;
}
.van-icon-refund-o {
	color: rgb(117, 64, 0);
}
.van-icon-qr {
	color: rgb(208, 45, 96);
}
.van-icon-orders-o {
	color: rgb(54, 95, 245);
}
.van-icon-after-sale {
	color: rgb(242, 154, 39);
}
.van-icon-orders-o {
	color: rgb(34, 255, 78);
}
.van-icon-balance-list-o {
	color: rgb(208, 10, 125);
}
.van-icon-cash-on-deliver {
	color: rgb(54, 95, 245);
}
.van-icon-todo-list-o {
	color: rgb(242, 154, 39);
}
.van-icon-closed-eye {
	color: rgb(90,10, 209);
}
.van-icon-exchange {
	color: rgb(117, 64, 230);
}
.van-icon-live {
	color: rgb(48, 128, 20);
}
</style>
